import { AxiosRequestConfig } from 'axios';

class ExportsRequestConfig {
  getFiilesList = (userId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'DownloadManager/GetDocumentsList',
    data: {
      UserId: userId
    }
  });
  getFilesCounter = (userId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'DownloadManager/GetUserCounters',
    data: {
      UserId: userId,
      ProductActive: true
    }
  });
  deleteDocument = (documentId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'DownloadManager/DeleteDocument',
    data: {
      DocumentId: documentId
    }
  });
  getDocumentState = (documentId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'DownloadManager/GetDocumentState',
    data: {
      DocumentId: documentId
    }
  });

  downloadZip = (ZipFileName: string, DocumentIds: string[]): AxiosRequestConfig => ({
    method: 'POST',
    url: 'DownloadManager/DownloadFilesAsZip',
    responseType: 'blob',
    data: {
      ZipFileName,
      DocumentIds
    }
  });
  downloadFile = (documentId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'DownloadManager/DownloadFile',
    responseType: 'blob',
    data: {
      documentId
    }
  });
}

export const exportsRequestConfig = new ExportsRequestConfig();
